var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "theme-toggle",
    "class": {
      'is-dark': _vm.isDark
    },
    attrs: {
      "type": "button",
      "aria-label": _vm.isDark ? 'Prepnúť na svetlú tému' : 'Prepnúť na tmavú tému',
      "aria-pressed": _vm.isDark ? 'true' : 'false',
      "title": _vm.isDark ? 'Svetlá téma' : 'Tmavá téma'
    },
    on: {
      "click": _vm.toggleTheme
    }
  }, [_c('span', {
    staticClass: "theme-toggle__icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.isDark ? '☾' : '☀'))]), _vm._m(0)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "theme-toggle__track",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "theme-toggle__thumb"
  })]);

}]

export { render, staticRenderFns }